<template>
    <div>
        <h1>국민건강보험공단 보유 건강정보 열람을 위한 개인(민감)정보 수집·이용 동의 및 제3자 제공 동의</h1>
        한국보건의료정보원은 아래의 공공기관 및 의료기관이 보유하고 있는 개인(민감)정보를 개인정보 보호법 제35조의2에 따라 정보주체가 지정하는 기관으로부터 제공받는 방법으로 아래와 같이 수집하여 정보주체가 지정하는 특수전문기관에 전송하고자 합니다.<br>
        서비스 이용을 위해 아래의 개인(민감)정보 수집 및 이용에 대한 내용을 자세히 읽어보신 후 동의 여부를 결정하여 주시기 바랍니다.<br>
        ※ 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.<br>
        <h3>[개인(민감)정보의 수집·이용 목적]</h3>
        정보주체가 지정한 보건의료 마이데이터 전송<br>
        <h3>[개인(민감)정보의 보유·이용 기간]</h3>
        한국보건의료정보원은 정보주체의 동의에 따라 수집하는 아래의 개인(민감)정보를 암호화하여 정보주체가 지정한 특수전문기관에 중계 전송하고 보유하지 않습니다.<br>
        <h3>[수집하려는 개인(민감) 정보의 항목]</h3>
        개인(민감)정보 보유 기관: 국민건강보험공단<br>
        수집하려는 개인(민감)정보의 항목: 건강검진 정보, 진료내용정보(최근 1년간)<br>
        건강검진 정보(최근 10년간), 영유아 정보(최근 5년간), 암건강검진정보, 대상자 현황, 병의원/약국 명칭, 진료개시일, 진료형태, 방문입원일수, 처방횟수, 본인부담금, 병의원 소재지<br>
        <h3>[개인(민감)정보 제공(전송) 내역]</h3>
        · 개인(민감)정보 보유 기관: 국민건강보험공단<br>
        · 제공받는 기관: 특수전문기관(정보주체가 지정한 특수전문기관)<br>
        · 제공 목적: 정보주체의 요구에 따른 개인(민감)정보 전송<br>
        · 제공 항목: 위의 “[전송요구에 따라 수집하려는 (민감)정보의 항목]” 중 정보주체가 수집·전송에 동의한 항목<br>
        · 제공받는 기관의 보유·이용 기간: 회원탈퇴 시까지<br>
        <h3>[기타 고지 사항]</h3>
        한국보건의료정보원은 개인정보 보호법 제35조의2에 따른 개인정보의 전송 요구에 관한 사무를 수행하기 위하여 개인정보보호법 시행령 제62조의2 제3항에 근거하여 아래와 같이 주민등록번호를 처리합니다.<br>
        · 제공받는 기관: 국민건강보험공단<br>
        · 제공 목적: 개인정보 전송을 위한 개인(민감)정보 수집<br>
        · 제공 항목: 주민등록번호<br>
        · 제공받는 기관의 보유·이용 기간: 해당 기관에서 개인(민감)정보 제공 시까지<br><br>
        ※ 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataNhis'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/Nhis.vue